import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=86d3aabc&scoped=true"
import script from "./MenuButton.vue?vue&type=script&lang=js"
export * from "./MenuButton.vue?vue&type=script&lang=js"
import style0 from "./MenuButton.vue?vue&type=style&index=0&id=86d3aabc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d3aabc",
  null
  
)

export default component.exports